import React from "react"

import StoryBlockComponent from "./StoryBlock"

import storyblockFactory from "./storyblock.factory"

export const StoryBlock = props => {
  const componentProps = storyblockFactory.transform(props)
  return <StoryBlockComponent {...componentProps} />
}

export default StoryBlock
